import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CorporateService } from 'src/app/services/corporate.service';
import { Location } from '@angular/common';
@Component({
    selector: 'app-confirm-discount',
    templateUrl: './confirm-discount.component.html',
    styleUrls: ['./confirm-discount.component.css']
})
export class ConfirmDiscountComponent implements OnInit {
    title: string;
    confirmationMessage: string;
    type: any;
    api_error: any;
    api_success: any;
    disableConfirmbtn = false;
    btndisabled  = false;
    constructor(public dialogRef: MatDialogRef<ConfirmDiscountComponent>,
        private matDialogRef: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private corporateService: CorporateService,
        private _location: Location,
        private location: Location,
    ) {
    }
    ngOnInit() {
        this.title = this.data['title'];
        this.type = this.data['type'];
        this.confirmationMessage = this.title;
    }
    onConfirm() {
        this.dialogRef.close();
    }
    goBacktoList() {
        this.location.back();
      }
}
